export type Scope = 'team' | 'member'
type RegionOption = { label: string; value: number }

export type QuotaLimits = {
  meshNet: number
  instanceQty: number
  snapQty: number
  storageBytes: number
}

export type PermissionForm = {
  enableACL: boolean
  regions: number[]
  gpuMachineCap: boolean
  cpuMachineCap: boolean
  vgpuMachineCap: boolean
  processorModels: string[]
  officialImageCap: boolean
  images: string[]
  meshNetQuota: number
  meshEndpointQuota: number
  instanceQtyQuota: number
  snapQtyQuota: number
  storageCapBytesQuota: number
}

export type AcceleratorCode =
  | 'NVIDIA_L40S_PCIe'
  | 'NVIDIA_A100_SXM4_80GB'
  | 'NVIDIA_GEFORCE_RTX_4090'
  | 'NVIDIA_RTX_6000_ADA'
  | 'NVIDIA_H100_SXM5'
  | 'INTEL_XEON_PLATINUM_8468'
  | 'INTEL_XEON_PLATINUM_8558'

export const ACCELERATOR_CATALOG: Array<{
  code: AcceleratorCode
  label: string
  processorModel: string
}> = [
  { code: 'NVIDIA_L40S_PCIe', label: 'NVIDIA L40S PCIe', processorModel: 'NVIDIA L40S PCIe' },
  {
    code: 'NVIDIA_A100_SXM4_80GB',
    label: 'NVIDIA A100-SXM4-80GB',
    processorModel: 'NVIDIA A100-SXM4-80GB',
  },
  {
    code: 'NVIDIA_GEFORCE_RTX_4090',
    label: 'NVIDIA GeForce RTX 4090',
    processorModel: 'NVIDIA GeForce RTX 4090',
  },
  {
    code: 'NVIDIA_RTX_6000_ADA',
    label: 'NVIDIA RTX 6000 Ada',
    processorModel: 'NVIDIA RTX 6000 Ada',
  },
  { code: 'NVIDIA_H100_SXM5', label: 'NVIDIA H100 SXM5', processorModel: 'NVIDIA H100 SXM5' },
  {
    code: 'INTEL_XEON_PLATINUM_8468',
    label: 'Intel(R) Xeon(R) Platinum 8468',
    processorModel: 'Intel(R) Xeon(R) Platinum 8468',
  },
  {
    code: 'INTEL_XEON_PLATINUM_8558',
    label: 'Intel(R) Xeon(R) Platinum 8558',
    processorModel: 'Intel(R) Xeon(R) Platinum 8558',
  },
]

export function findAccelByCode(code: AcceleratorCode) {
  return ACCELERATOR_CATALOG.find((a) => a.code === code)!
}

export type InstanceTableRow = {
  id: string
  acceleratorCode: AcceleratorCode
  displayModel: string
  processorModel: string

  gpus: number
  gpuRamGB: number
  region: string
  vcpus: number
  ramGB: number
  pricePerDayCredits: number

  checked?: boolean
}

export type PaginationMeta = {
  page: number
  pageSize: number
  total: number
}

export type InstanceTable = {
  rows: InstanceTableRow[]
  pagination: PaginationMeta
}

export const REGION_OPTIONS: RegionOption[] = [
  { label: 'TW-01', value: 0 },
  { label: 'TW-02', value: 1 },
  { label: 'TW-03', value: 2 },
  { label: 'TW-04', value: 3 },
  { label: 'TW-05', value: 4 },
  { label: 'JP-01', value: 5 },
]
